import { Outlet, useLocation } from "react-router";
import ReactGA from "react-ga4";
import { useEffect } from "react";

const AnalyticsTracker = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: pathname });
    }, [pathname]);

    return <Outlet />;
};

export default AnalyticsTracker;
